import { CURRENCY_CODE_TO_CURRENCY_SYMBOL_SEPARATOR as o } from "./moneyUtils.consts.mjs";
const e = o.EUR, n = (r, t = e, C = o) => typeof r != "string" ? t : C[r] ?? t;
export {
  n as getCurrencySymbolSeparatorByCode
};
//# sourceMappingURL=getCurrencySymbolSeparatorByCode.mjs.map
